(() => {
  const normalizeSize = (value) => String(value || '')
    .toLowerCase()
    .replace(/inches|inch|in\b/g, '')
    .replace(/[-_\s"'”″]/g, '');

  const getProductRoot = (productId) => document.querySelector(
    `.iy-bath-main[data-iy-bath-product-id="${CSS.escape(productId)}"]`
  );

  const getSizeKey = (element) => normalizeSize(element.dataset.iyBathSizeKey);

  const initSizeSync = (root) => {
    const syncRoots = [...root.querySelectorAll('[data-iy-bath-size-sync][data-iy-bath-product-id]')];
    const productIds = [...new Set(syncRoots.map((element) => element.dataset.iyBathProductId))];

    productIds.forEach((productId) => {
      const productRoot = getProductRoot(productId);
      if (!productRoot) return;

      const allSyncRoots = [...document.querySelectorAll(
        `[data-iy-bath-size-sync][data-iy-bath-product-id="${CSS.escape(productId)}"]`
      )];
      const keyedElements = allSyncRoots.flatMap((element) => [
        ...element.querySelectorAll('[data-iy-bath-size-key]')
      ]);
      const availableKeys = [...new Set(keyedElements.map(getSizeKey).filter(Boolean))];
      if (!availableKeys.length) return;

      const optionInputs = () => [...productRoot.querySelectorAll('input[name^="option"], select[name^="option"]')];
      const selectedValues = () => optionInputs()
        .filter((input) => input.tagName === 'SELECT' || input.checked)
        .map((input) => normalizeSize(input.value));

      const activeKey = () => availableKeys.find((key) => selectedValues().includes(key)) || availableKeys[0];

      const sync = () => {
        const selectedKey = activeKey();

        allSyncRoots.forEach((syncRoot) => {
          syncRoot.querySelectorAll('[data-iy-bath-size-target]').forEach((target) => {
            const active = getSizeKey(target) === selectedKey;
            target.hidden = !active;
            target.setAttribute('aria-hidden', String(!active));
          });

          syncRoot.querySelectorAll('[data-iy-bath-size-tab]').forEach((tab) => {
            const active = getSizeKey(tab) === selectedKey;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
          });
        });
      };

      const selectNativeSize = (sizeKey) => {
        const input = optionInputs().find((candidate) => normalizeSize(candidate.value) === sizeKey);
        if (!input || input.disabled) return;

        if (input.tagName === 'SELECT') {
          const option = [...input.options].find((item) => normalizeSize(item.value) === sizeKey);
          if (!option) return;
          if (input.value === option.value) return sync();
          input.value = option.value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        if (!input.checked) input.click();
        else sync();
      };

      allSyncRoots.forEach((syncRoot) => {
        syncRoot.querySelectorAll('[data-iy-bath-size-tab]').forEach((tab) => {
          if (tab.dataset.iyBathTabReady === 'true') return;
          tab.dataset.iyBathTabReady = 'true';
          tab.addEventListener('click', () => selectNativeSize(getSizeKey(tab)));
          tab.addEventListener('keydown', (event) => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            const tabs = [...tab.parentElement.querySelectorAll('[data-iy-bath-size-tab]')];
            const current = tabs.indexOf(tab);
            let next = current;
            if (event.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
            if (event.key === 'ArrowRight') next = (current + 1) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            event.preventDefault();
            tabs[next].focus();
            tabs[next].click();
          });
        });
      });

      if (productRoot.dataset.iyBathSizeReady !== 'true') {
        productRoot.dataset.iyBathSizeReady = 'true';
        productRoot.addEventListener('change', sync);
        const forms = new Set(optionInputs().map((input) => input.form).filter(Boolean));
        forms.forEach((form) => form.addEventListener('variant:changed', sync));
      }

      sync();
    });
  };

  const initScrollProgress = (root) => {
    root.querySelectorAll('[data-iy-bath-scroll]').forEach((scroller) => {
      if (scroller.dataset.iyBathScrollReady === 'true') return;
      const progress = scroller.nextElementSibling;
      if (!progress || !progress.matches('[data-iy-bath-scroll-progress]')) return;
      scroller.dataset.iyBathScrollReady = 'true';

      const update = () => {
        const maximum = scroller.scrollWidth - scroller.clientWidth;
        const amount = maximum > 0 ? Math.min(1, Math.max(0, scroller.scrollLeft / maximum)) : 0;
        progress.hidden = maximum <= 2;
        const thumb = progress.querySelector('span');
        if (thumb) thumb.style.transform = `translateX(${amount * 212.5}%)`;
      };

      scroller.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(scroller);
      update();
    });
  };

  const init = (root = document) => {
    initSizeSync(root);
    initScrollProgress(root);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
